
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="py-16 md:py-20 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-seafarer-orange to-seafarer-purple opacity-90"></div>
      <div className="absolute inset-0 bg-[url('/pattern-bg.png')] mix-blend-multiply opacity-30"></div>
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Join Us in Restoring Dignity to Fishermen
          </h2>
          <p className="text-white/80 text-lg mb-8">
            Be part of our movement to create sustainable housing solutions and empower
            fishermen communities across Namibia. Together, we can make a difference.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Button asChild className="bg-white text-seafarer-orange hover:bg-white/90 border-2 seafarer-btn">
              <Link to="/contact">
                Get Involved <ArrowRight size={16} className="ml-2" />
              </Link>
            </Button>
            <Button asChild variant="outline" className="border-white text-seafarer-orange hover:bg-white/10 border-2 seafarer-btn">
              <Link to="/projects">View Our Projects</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
